import styled from 'styled-components';

//Empty container for testing purposes
const EmptyContainer = styled.div<React.CSSProperties>``;

export default EmptyContainer;
